import { MaintenanceWindow, SiteConfiguration } from "../../../dtos/site";

export const DEFAULT_SITE_CONFIGURATION: SiteConfiguration = {
    automaticSessionAbandonment: true,
};

export const DEFAULT_MAINTENANCE_WINDOW: MaintenanceWindow = {
    startTime: "00:00:00", // should be in DB_TIME_FORM_REG_EX
    endTime: "06:00:00", // should be in DB_TIME_FORM_REG_EX
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true,
    sunday: true,
};

export const EMPTY_MAINTENANCE_WINDOW: MaintenanceWindow = {
    startTime: "00:00:00",
    endTime: "00:00:00",
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
};
